import { Controller } from "@hotwired/stimulus"

// Streams the site's indexing log while a crawl/index is running: polls the
// crawl_log endpoint for JSON and swaps the <pre> contents in place, so the page
// reflects progress instead of a snapshot frozen at page load. Stops as soon as
// the site reaches a terminal state, so it never polls forever.
const ACTIVE = ["crawling", "indexing"]

export default class extends Controller {
  static targets = ["output", "timestamp"]
  static values = {
    url: String,
    status: String,
    interval: { type: Number, default: 3000 }
  }

  connect() {
    if (ACTIVE.includes(this.statusValue)) this.scheduleNext()
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  scheduleNext() {
    this.timer = setTimeout(() => this.poll(), this.intervalValue)
  }

  poll() {
    fetch(this.urlValue, { headers: { Accept: "application/json" } })
      .then((r) => r.json())
      .then((data) => {
        this.render(data)
        // A finished crawl gets one last render (above) before we stop, so the
        // final lines are never lost.
        if (ACTIVE.includes(data.status)) this.scheduleNext()
      })
      .catch(() => {
        // Back off rather than hammer a struggling server; a transient blip
        // must not kill the stream.
        this.timer = setTimeout(() => this.poll(), this.intervalValue * 2)
      })
  }

  render(data) {
    if (this.hasOutputTarget && typeof data.content === "string") {
      // Keep following the tail only if the reader is already at the bottom, so
      // scrolling back to inspect an entry isn't yanked away on every poll.
      const el = this.outputTarget
      const pinned = el.scrollHeight - el.scrollTop - el.clientHeight < 40
      el.textContent = data.content
      if (pinned) el.scrollTop = el.scrollHeight
    }
    if (this.hasTimestampTarget && data.generated_at) {
      this.timestampTarget.textContent = data.generated_at
    }
  }
}
